import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Row } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';



const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class MergerSubList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            mergerSubs: [],
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            mergerSubDetails: [],
            sourceDestinationOptions: [{value: "S", label: "Source"},{value: "D", label: "Destination"}]

        };

        
    }
    

    async componentDidMount() {
        console.log("In MergerSubDetailList componentDidMount");
        this.setState({ isLoading: true });      
        this.setState({ showAlert: false });
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ mergerSubs: [] });        
    }

   

    

    
    
    
    

    

  

    handleSave = async (event) => {

        this.setState({ showAlert: false });
        

        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            
                if (data[i].hasOwnProperty("modified")) {
                    console.log("Saving");
                    if (data[i].modified === true) {
                        const validation = this.props.validateRelatedRecord(data[i], "mergerSubDetails");
                       
                        if (validation[0] === true) {
                            console.log(validation[0])
                        
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i].merger_sub_detail_id = result.id;
                                        this.setState({ savingNewRecord: false });                                        

                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                                if (data[i].new_record === true) {
                                    console.log("Going to remove the invalid new record");
                                    data.splice(i, 1);
                                    this.setState({ savingNewRecord: false });   
                                }
                            }
                        }
                    }
                    else {
                        this.setState({ errorMessage: validation[1] });
                        this.setState({ showAlert: true });
                    }
                    }
                    

                }
            
        }  
        if (data.length>0 ){
            if (data[0].hasOwnProperty("sort_order")) {
                data.sort(function (a, b) { return a.sort_order - b.sort_order });
            }
            
        }
        this.props.updateTableState(data);

    }

    
    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, "mergerSubDetails", "merger_sub_detail_id");
        } catch (e) {
            alert("Error saving");
        }
    }
    
    
    async addMergerSubDetailRecord(mergersubid, source_or_dest){
    
        //await this.handleSave();
        let data = [...this.props.data];
        
        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
            property_key: "",
            merger_sub_detail_id: "",
            merger_sub_id: this.props.mergersubid,
            source_or_dest: source_or_dest,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data);

          

    }

    handleInputChange = (cellInfo, event) => {
        
        let data = [...this.props.data];
        for(var i =0; i<data.length;i++){
            if (data[i].merger_sub_detail_id === cellInfo.original.merger_sub_detail_id){
                data[i][cellInfo.column.id] = event.target.value;
                data[i].modified = true;
            }
        }
        this.props.updateTableState(data);
    };

    renderPropertyKeyEditable = cellInfo => {
        console.log(cellInfo);
        if(cellInfo){
            const record = this.props.data.filter(ms => ms.merger_sub_detail_id === cellInfo.original.merger_sub_detail_id);
            console.log(record);
            if (record.length>=0){
                const cellValue = record[0].property_key;
            

                return (
                    <input
                        onChange={this.handleInputChange.bind(null, cellInfo)}
                        onBlur={this.handleSave.bind(null)}
                        type="text"
                        className="no-border form-control"
                        value={cellValue!=null? cellValue:""}

                    />
                );
                 }
            else{
                return (
                    <input
                        onChange={this.handleInputChange.bind(null, cellInfo)}
                        onBlur={this.handleSave.bind(null)}
                        type="text"
                        className="no-border form-control"
                        value=""

                    />
                );
            }
                        
        }
        
    }

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete merger sub division");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            for(var i =0;i<data.length;i++){
                console.log( cellInfo.original.merger_sub_detail_id);
                console.log(data[i].merger_sub_detail_id);
                if (data[i].merger_sub_detail_id === cellInfo.original.merger_sub_detail_id){
                    data[i].archived_date = new Date();
                    data[i].modified = true;
                    //this.props.updateTableState(data);
                    console.log(i);
                    await this.handleDataSave(data[i], data[i].merger_sub_detail_id).then((result) => {
                        console.log("In save callback")
                        data.splice(i, 1);
                        this.props.updateTableState(data);
                    }
                    
                    )
                    return true;
                }
            }
            
            
        };
    };
    
    renderTable(data) {
        
    return (
        <div style={{ padding: "20px" }}>
            
        <br />
        
        <Row>
            
            <Col lg={5}>
                <Row>
                    <Col className="text-right" >                            
                        <Button variant="secondary" size="sm" onClick={e => this.addMergerSubDetailRecord(this.props.mergersubid,"S")}>Add</Button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ReactTable
                            data={this.props.data.filter(ms => ms.source_or_dest == "S")}  
                            columns={[
                                        {
                                            id: 'property_key',
                                            Header: 'As they were',            
                                            accessor: 'property_key',
                                            maxWidth: 150,
                                            Cell: this.renderPropertyKeyEditable
                                        },{
                                            Header: '',
                                            accessor: 'merger_sub_detail_id',
                                            maxWidth: 65,
                                            Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
                                        }
                                        ]}
                            defaultPageSize={20}
                            showPagination={false}
                        />
                    </Col>
                </Row>
            </Col>

            <Col  lg={5}>
            <Row>
                    <Col className="text-right" >                            
                        <Button variant="secondary" size="sm" onClick={e => this.addMergerSubDetailRecord(this.props.mergersubid,"D")}>Add</Button>
                    </Col>
                </Row>
            <Row>
                    <Col>
                        <ReactTable
                            data={this.props.data.filter(ms => ms.source_or_dest == "D")}  
                            columns={[
                                        {
                                            id: 'property_key',
                                            Header: 'What they became',            
                                            accessor: 'property_key',
                                            maxWidth: 150,
                                            Cell: this.renderPropertyKeyEditable
                                        },{
                                            Header: '',
                                            accessor: 'merger_sub_detail_id',
                                            maxWidth: 65,
                                            Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
                                        }
                                        ]}
                            defaultPageSize={20}
                            showPagination={false}
                        />
                </Col>
                </Row>
            </Col>
        </Row>
        </div>
    );
    }
                    
                              
                

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

    
    renderComponent() {
        return (
            <div className="mergersubs">
                <Alert show={this.state.showAlert} variant="danger">{this.state.errorMessage}</Alert>
              
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.props.data) : this.renderTable(this.props.data)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="AgentList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
